<script>
import ArtUsages from './ArtUsages.vue'
import { formatAnnotation } from '@/components/ArtUsages.vue'
import { currency } from '@/utils/currency.js'

export default {
  name: 'ArtUsagesMin',
  extends: ArtUsages,
  data() {
    return {
      fields: ArtUsagesMinFields,
    }
  },
}

export const ArtUsagesMinFields = [
  {key: 'thumbnail', label: '', class: 'column-narrow', tdClass: 'p-0 align-middle text-center'},
  {key: 'annotation', formatter: formatAnnotation, },
  {
    key: 'amount_due',
    label: 'Amount',
    class: 'text-right text-tabular column-narrow',
    formatter: i => currency(i, 100),
  },
]
</script>
